import { render, staticRenderFns } from "./QuickSightReportsList.vue?vue&type=template&id=298b1413&scoped=true"
import script from "./QuickSightReportsList.vue?vue&type=script&lang=ts"
export * from "./QuickSightReportsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b1413",
  null
  
)

export default component.exports